var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentsReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.23126C22 2.99897 20.9926 2 19.75 2H9.25C8.00736 2 7 2.99897 7 4.23126V6.5H14.75C16.784 6.5 18.5 8.1164 18.5 10.1921V13.1563H19L20.6643 15.2194C21.1072 15.7684 22 15.4578 22 14.7548V4.23126Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.1921C2 8.98144 3.00736 8 4.25 8H14.75C15.9926 8 17 8.98144 17 10.1921V17.5789C17 18.7896 15.9926 19.7711 14.75 19.7711H5L3.33565 21.7243C2.89277 22.2637 2 21.9586 2 21.2679V10.1921ZM10.8742 10.3587C10.5596 10.0425 10.0198 10.2653 10.0198 10.7113V12C8.49041 12 5.55078 12.9354 5.10238 16.5314C5.05823 16.8855 5.25862 16.98 5.54609 16.7686C6.5843 16.0053 8.84394 15 10.0198 15V16.2887C10.0198 16.7347 10.5596 16.9575 10.8742 16.6413L13.2981 14.2054C13.6863 13.8152 13.6863 13.1848 13.2981 12.7946L10.8742 10.3587Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsReply);
export default __webpack_public_path__ + "static/media/comments-reply.5d8290b624b42729352ffa6915614e57.svg";
export { ForwardRef as ReactComponent };